module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/gift-subscription_42e71f.jpg";